/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { ClusterStates } from './server';
import { CIColors } from './theme';

export const OAUTH2_PROVIDERS = ['github', 'google', 'microsoft'] as const;
export type OAuth2Providers = (typeof OAUTH2_PROVIDERS)[number];

export const KubernetesIdentifier = {
  Regex: /^[a-z][a-z0-9.\- ]{2,30}[a-z0-9]$/i,
  MinLength: 4,
  MaxLength: 32,
};

export const ClusterStateOrder = {
  [ClusterStates.Running]: 1,
  [ClusterStates.Starting]: 2,
  [ClusterStates.Stopping]: 3,
  [ClusterStates.Stopped]: 4,
  [ClusterStates.Updating]: 5,
  [ClusterStates.Creating]: 6,
  [ClusterStates.Importing]: 7,
  [ClusterStates.Unavailable]: 8,
  [ClusterStates.Error]: 9,
};

export const DefaultClusterLimits = {
  Cpu: {
    Min: 0.25,
  },
  MemoryGbs: {
    Min: 1,
    Max: 1000, // Provided just for defining unit options
  },
  StorageGbs: {
    Min: 1,
    Max: 1000, // Provided just for defining unit options
  },
  Replicas: {
    Min: 0,
    Max: 10,
  },
};

export const DefaultAllowedSourceRange = '0.0.0.0/32';

export const Languages = ['en', 'de'] as const;
export type Language = (typeof Languages)[number];
export const DefaultLanguage = 'en';

export const AdviceTypes = [
  'MODULE_BLOAT',
  'MODULE_COLLECT_STATS',
  'MODULE_CONFIG',
  'MODULE_INDEX_ANOMALIES',
  'MODULE_RUNTIME',
  'MODULE_SAMPLE',
  'MODULE_SECURITY',
  'MODULE_STORAGE',
  'MODULE_TABLE_ANOMALIES',
  'MODULE_VARIOUS',
] as const;
export type AdviceType = (typeof AdviceTypes)[number];

export const AdviceSeverities = ['NOTICE', 'REMARK', 'LOW', 'MEDIUM', 'HIGH', 'SHOWSTOPPER'] as const;
export type AdviceSeverity = (typeof AdviceSeverities)[number];

export const AdviceSeverityColor = {
  NOTICE: CIColors.Success,
  REMARK: '#8BC34A',
  LOW: '#FFEB3B',
  MEDIUM: CIColors.Warning,
  HIGH: '#FF5722',
  SHOWSTOPPER: CIColors.Error,
} as const satisfies Record<AdviceSeverity, string>;
